export type Movie = {
  id: string;
  title: string;
  titleEn: string;
  year: number;
  region: "日本" | "韩国";
  lengthType: "长片" | "短片";
  duration: number;
  genres: string[];
  director: string;
  cast: string[];
  synopsis: string;
  cover: string;
  rating: number;
  publishDate: string;
  collections: string[];
};

export const movies: Movie[] = [
  {
    id: "rainy-night-poem",
    title: "雨夜之诗",
    titleEn: "Poem of a Rainy Night",
    year: 2019,
    region: "日本",
    lengthType: "长片",
    duration: 118,
    genres: ["剧情", "文艺", "禁忌"],
    director: "白石凉介",
    cast: ["森川织江", "高濑和也", "小野原澄"],
    synopsis:
      "东京郊外一间旧书店，店主在连绵的梅雨里接待了一位每晚都来避雨的陌生女子。两人从借书、还书聊到各自破碎的婚姻，语言渐渐失效，只剩下雨声与呼吸。影片用极少的对白和大量留白，讲一段无法被命名的关系如何在雨停之前走到尽头。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20art%20house%20movie%20poster%20artwork%2C%20silhouette%20of%20a%20woman%20standing%20by%20a%20rain-streaked%20window%20at%20night%2C%20deep%20crimson%20and%20amber%20light%2C%20film%20noir%20atmosphere%2C%20moody%20elegant%20composition%2C%20no%20text&width=600&height=900&seq=movie-cover-01&orientation=portrait",
    rating: 8.7,
    publishDate: "2024-11-18",
    collections: ["popular", "japan", "themes"],
  },
  {
    id: "neon-and-lips",
    title: "霓虹与唇",
    titleEn: "Neon and Lips",
    year: 2023,
    region: "韩国",
    lengthType: "长片",
    duration: 105,
    genres: ["都市", "浪漫", "激情"],
    director: "尹智勋",
    cast: ["韩瑞妍", "车敏宰", "徐恩率"],
    synopsis:
      "首尔江南的一间深夜酒吧，调酒师与常客在霓虹灯下交换彼此的秘密。她白天是出版社编辑，他刚刚结束一段长达七年的婚姻。两个人的关系像一杯永远差最后一口的酒，既不肯喝完，也不愿放下。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20poster%20artwork%20of%20a%20neon-lit%20night%20bar%20with%20the%20elegant%20silhouette%20of%20a%20woman%2C%20crimson%20and%20warm%20amber%20glow%2C%20rain-soaked%20Seoul%20street%20bokeh%2C%20modern%20noir%20aesthetic%2C%20no%20text&width=600&height=900&seq=movie-cover-02&orientation=portrait",
    rating: 8.3,
    publishDate: "2024-12-06",
    collections: ["recent", "popular", "korea", "themes"],
  },
  {
    id: "crimson-room",
    title: "赤色房间",
    titleEn: "The Crimson Room",
    year: 2015,
    region: "日本",
    lengthType: "长片",
    duration: 124,
    genres: ["悬疑", "心理", "禁忌"],
    director: "远山启一",
    cast: ["柊木冴子", "井上英治", "真木亘"],
    synopsis:
      "一间只在夜里打开的红色房间，接待着各自带着秘密的客人与主人。影片以三段交错的时间线，慢慢揭开一场关于占有与自由的赌局，谁是猎人、谁是猎物，直到最后一刻才见分晓。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20thriller%20poster%20artwork%2C%20single%20deep%20crimson%20room%20with%20heavy%20curtains%20and%20a%20lone%20shadowed%20figure%2C%20dramatic%20chiaroscuro%20lighting%2C%20mysterious%20elegant%20atmosphere%2C%20no%20text&width=600&height=900&seq=movie-cover-03&orientation=portrait",
    rating: 8.9,
    publishDate: "2024-09-22",
    collections: ["popular", "japan", "classic"],
  },
  {
    id: "summer-tide",
    title: "夏日潮汐",
    titleEn: "Summer Tide",
    year: 2024,
    region: "日本",
    lengthType: "长片",
    duration: 98,
    genres: ["青春", "浪漫", "文艺"],
    director: "宫原理沙",
    cast: ["藤崎葵", "南云翔", "江口沙耶"],
    synopsis:
      "海边小镇的最后一个夏天，两个十七岁的少年少女在废弃的灯塔里度过了整个假期。潮水每天涨落两次，他们的关系却只有一次涨潮的机会。影片用胶片质感留住青春里那种既灼热又羞怯的靠近。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20summer%20movie%20poster%2C%20two%20teenage%20silhouettes%20on%20a%20seaside%20lighthouse%20at%20golden%20sunset%2C%20warm%20amber%20and%20crimson%20graduation%20tones%2C%20nostalgic%20film%20grain%20aesthetic%2C%20no%20text&width=600&height=900&seq=movie-cover-04&orientation=portrait",
    rating: 8.5,
    publishDate: "2025-01-10",
    collections: ["recent", "japan", "themes"],
  },
  {
    id: "seoul-midnight-train",
    title: "首尔午夜列车",
    titleEn: "Seoul Midnight Train",
    year: 2022,
    region: "韩国",
    lengthType: "长片",
    duration: 112,
    genres: ["都市", "悬疑", "浪漫"],
    director: "朴度允",
    cast: ["李夏琳", "郑在浩", "金秀彬"],
    synopsis:
      "末班地铁上，两个陌生人因为一只遗落的皮包而相识。他们约定每周三在同一节车厢见面，却从不交换真名。当其中一人开始调查对方的身份，城市夜晚的安全感随之崩塌。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20poster%20of%20an%20empty%20midnight%20subway%20carriage%2C%20a%20woman%20and%20man%20sitting%20apart%20under%20crimson%20lighting%2C%20reflective%20windows%2C%20moody%20urban%20night%20atmosphere%2C%20no%20text&width=600&height=900&seq=movie-cover-05&orientation=portrait",
    rating: 8.6,
    publishDate: "2024-10-30",
    collections: ["popular", "korea", "themes"],
  },
  {
    id: "flame-of-daylight",
    title: "白昼之焰",
    titleEn: "Flame of Daylight",
    year: 2021,
    region: "韩国",
    lengthType: "短片",
    duration: 42,
    genres: ["剧情", "激情", "都市"],
    director: "闵书妍",
    cast: ["吴佳恩", "柳时贤"],
    synopsis:
      "一个普通的周三午后，两个在咖啡馆隔着玻璃对望了三个月的人终于说了第一句话。四十二分钟的短片，全部发生在同一间公寓里，从午后到黄昏，讲述心动如何在一场雨里失控。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20short%20film%20poster%2C%20abstract%20sunlit%20apartment%20interior%20with%20flowing%20curtains%20and%20two%20blurred%20figures%2C%20warm%20amber%20daylight%20with%20crimson%20shadows%2C%20artistic%20minimal%20composition%2C%20no%20text&width=600&height=900&seq=movie-cover-06&orientation=portrait",
    rating: 8.1,
    publishDate: "2024-08-14",
    collections: ["popular", "korea", "themes"],
  },
  {
    id: "sakura-inn",
    title: "樱花旅馆",
    titleEn: "Sakura Inn",
    year: 2008,
    region: "日本",
    lengthType: "长片",
    duration: 132,
    genres: ["经典", "文艺", "爱情"],
    director: "大庭修三",
    cast: ["绪方千鹤", "大庭隆", "坂井澪"],
    synopsis:
      "山中一家开了六十年的旅馆，女主人独自守着满院樱花。一位每年春天都来住一晚的老客人，带着一封从未寄出的信。樱花只开七天，他们的故事却拖了整整二十年。",
    cover:
      "https://readdy.ai/api/search-image?query=Classic%20Japanese%20cinema%20poster%20artwork%2C%20traditional%20wooden%20inn%20corridor%20with%20falling%20cherry%20blossom%20petals%2C%20warm%20amber%20lantern%20light%20and%20deep%20crimson%20tones%2C%20nostalgic%20elegant%20composition%2C%20no%20text&width=600&height=900&seq=movie-cover-07&orientation=portrait",
    rating: 9.1,
    publishDate: "2024-04-12",
    collections: ["classic", "popular", "japan", "themes"],
  },
  {
    id: "silent-love-letter",
    title: "沉默的情书",
    titleEn: "The Silent Letter",
    year: 2012,
    region: "韩国",
    lengthType: "长片",
    duration: 108,
    genres: ["经典", "爱情", "剧情"],
    director: "郑宇成",
    cast: ["文素熙", "赵贤宇", "崔允兒"],
    synopsis:
      "听障女子在图书馆工作，每天为一位从不借书的男人整理同一排书架。她用一封封没有寄出的信记录这段沉默的爱意，直到某天，书架上的书被人一本本借走。",
    cover:
      "https://readdy.ai/api/search-image?query=Classic%20romance%20film%20poster%2C%20quiet%20library%20aisle%20with%20dust%20motes%20in%20warm%20light%2C%20a%20woman%20reading%20alone%2C%20muted%20crimson%20and%20sepia%20palette%2C%20delicate%20melancholic%20mood%2C%20no%20text&width=600&height=900&seq=movie-cover-08&orientation=portrait",
    rating: 8.8,
    publishDate: "2024-03-08",
    collections: ["classic", "popular", "korea"],
  },
  {
    id: "glass-and-fog",
    title: "玻璃与雾",
    titleEn: "Glass and Fog",
    year: 2025,
    region: "日本",
    lengthType: "长片",
    duration: 96,
    genres: ["文艺", "心理", "禁忌"],
    director: "新井透",
    cast: ["雨宫玲", "沢渡圭", "小柳千秋"],
    synopsis:
      "玻璃工艺师与前来修复一面旧镜子的女子，在一间常年起雾的工作室里共处了十四天。镜子照出的不只是容貌，还有各自不愿承认的欲望。一封来自过去的信，让修复工作变成了一场自我审判。",
    cover:
      "https://readdy.ai/api/search-image?query=Artistic%20film%20poster%2C%20foggy%20glass%20workshop%20with%20an%20antique%20mirror%20reflecting%20a%20blurred%20female%20figure%2C%20dark%20crimson%20and%20cool%20gray%20atmosphere%2C%20painterly%20cinematic%20style%2C%20no%20text&width=600&height=900&seq=movie-cover-09&orientation=portrait",
    rating: 9.0,
    publishDate: "2025-06-20",
    collections: ["recent", "popular", "japan", "themes"],
  },
  {
    id: "han-river-winter",
    title: "汉江之冬",
    titleEn: "Winter on the Han",
    year: 2020,
    region: "韩国",
    lengthType: "长片",
    duration: 115,
    genres: ["剧情", "爱情", "都市"],
    director: "李承焕",
    cast: ["金多美", "朴叙准", "李知恩"],
    synopsis:
      "汉江边一间即将拆迁的摄影工作室，摄影师与前来取回旧照片的女人重逢。十年前他们在这里分开，十年后照片里的人和眼前的人都变了。整部影片在冬天的江风里慢慢解冻。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20winter%20poster%2C%20frozen%20Han%20river%20bank%20at%20dusk%20with%20two%20distant%20figures%20and%20city%20lights%2C%20crimson%20and%20steel%20gray%20palette%2C%20quiet%20melancholic%20atmosphere%2C%20no%20text&width=600&height=900&seq=movie-cover-10&orientation=portrait",
    rating: 8.4,
    publishDate: "2024-05-16",
    collections: ["popular", "korea", "themes"],
  },
  {
    id: "cat-and-platform",
    title: "猫与月台",
    titleEn: "The Cat and the Platform",
    year: 2017,
    region: "日本",
    lengthType: "短片",
    duration: 38,
    genres: ["文艺", "都市", "剧情"],
    director: "冈田千寻",
    cast: ["白石奈绪", "松冈亮"],
    synopsis:
      "末班车开走后，月台上只剩下一个等错车的女人和一只不肯离开的猫。三十分钟的短片，几乎全由一个长镜头完成，讲述城市里那种短暂却真实的互相陪伴。",
    cover:
      "https://readdy.ai/api/search-image?query=Minimal%20cinematic%20poster%2C%20empty%20train%20platform%20at%20night%20with%20a%20lone%20woman%20and%20a%20cat%2C%20amber%20lamps%20and%20deep%20crimson%20shadows%2C%20poetic%20urban%20loneliness%2C%20no%20text&width=600&height=900&seq=movie-cover-11&orientation=portrait",
    rating: 8.2,
    publishDate: "2024-07-03",
    collections: ["japan", "themes"],
  },
  {
    id: "rose-tattoo",
    title: "玫瑰纹身",
    titleEn: "Rose Tattoo",
    year: 2011,
    region: "日本",
    lengthType: "长片",
    duration: 121,
    genres: ["经典", "禁忌", "剧情"],
    director: "黑川玲二",
    cast: ["藤堂沙织", "黑川武", "水野丽"],
    synopsis:
      "横滨一家老纹身店里，女纹身师为一位即将离开这座城市的客人完成最后一朵玫瑰。三天三夜的刺青过程，也是两个人把话说完的最后机会。针脚落下，故事才真正开始。",
    cover:
      "https://readdy.ai/api/search-image?query=Classic%20noir%20poster%2C%20vintage%20tattoo%20studio%20interior%20with%20warm%20lamp%20light%20and%20a%20red%20rose%20motif%2C%20crimson%20and%20ink%20black%20palette%2C%20intimate%20atmospheric%20composition%2C%20no%20text&width=600&height=900&seq=movie-cover-12&orientation=portrait",
    rating: 8.6,
    publishDate: "2024-02-19",
    collections: ["classic", "japan", "themes"],
  },
  {
    id: "reflection-in-water",
    title: "水中倒影",
    titleEn: "Reflection in Water",
    year: 2023,
    region: "韩国",
    lengthType: "短片",
    duration: 51,
    genres: ["心理", "剧情", "文艺"],
    director: "申多允",
    cast: ["韩智秀", "尹泰河"],
    synopsis:
      "室内泳池的夜间闭馆时间，救生员与每天最后离开的泳客形成了一种默契。水面安静得能听见心跳，两个人都在等对方先说出那句不该说的话。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20poster%2C%20dark%20indoor%20swimming%20pool%20at%20night%20with%20rippling%20reflections%20and%20a%20female%20swimmer%20silhouette%2C%20teal-free%20crimson%20and%20amber%20underwater%20light%2C%20elegant%20moody%20atmosphere%2C%20no%20text&width=600&height=900&seq=movie-cover-13&orientation=portrait",
    rating: 8.3,
    publishDate: "2025-02-14",
    collections: ["recent", "korea", "themes"],
  },
  {
    id: "midnight-convenience",
    title: "午夜便利店",
    titleEn: "Midnight Convenience",
    year: 2024,
    region: "韩国",
    lengthType: "长片",
    duration: 102,
    genres: ["都市", "浪漫", "剧情"],
    director: "金到贤",
    cast: ["朴敏雅", "崔道允", "李瑞俊"],
    synopsis:
      "二十四小时便利店的夜班店员，和每天凌晨两点来买同一款咖啡的男人。他们从不问对方的姓名，却在一次停电的深夜里，把各自的人生讲完了大半。",
    cover:
      "https://readdy.ai/api/search-image?query=Late%20night%20convenience%20store%20exterior%20glowing%20warm%20amber%2C%20two%20figures%20talking%20inside%2C%20dark%20crimson%20city%20backdrop%2C%20cinematic%20slice%20of%20life%20poster%2C%20no%20text&width=600&height=900&seq=movie-cover-14&orientation=portrait",
    rating: 8.7,
    publishDate: "2025-03-28",
    collections: ["recent", "popular", "korea"],
  },
  {
    id: "gentle-trap",
    title: "温柔陷阱",
    titleEn: "The Gentle Trap",
    year: 2014,
    region: "日本",
    lengthType: "长片",
    duration: 110,
    genres: ["悬疑", "激情", "心理"],
    director: "桐生慎",
    cast: ["皆川结衣", "桐生亮介", "远野真希"],
    synopsis:
      "一位调查保险诈骗的律师，住进了嫌疑人名下的海边别墅。越接近真相，他越分不清自己是猎手还是被困住的那一个。这部影片关于诱惑，也关于人如何心甘情愿地被欺骗。",
    cover:
      "https://readdy.ai/api/search-image?query=Psychological%20thriller%20poster%2C%20seaside%20villa%20at%20dusk%20with%20long%20shadows%20and%20an%20open%20doorway%2C%20deep%20crimson%20and%20charcoal%20tones%2C%20tense%20elegant%20film%20noir%20composition%2C%20no%20text&width=600&height=900&seq=movie-cover-15&orientation=portrait",
    rating: 8.5,
    publishDate: "2024-06-11",
    collections: ["japan", "popular", "themes"],
  },
  {
    id: "last-bus-blue",
    title: "末班车之约",
    titleEn: "The Last Bus",
    year: 2018,
    region: "韩国",
    lengthType: "长片",
    duration: 109,
    genres: ["爱情", "文艺", "剧情"],
    director: "朴贤珠",
    cast: ["全素妍", "姜东元", "白智勋"],
    synopsis:
      "两个住在城市两端的人，只有在末班公交车上才有交集。他们用一站又一站的时间交换彼此的生活，却始终没有一起下过车。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20poster%2C%20night%20city%20bus%20window%20with%20reflections%20of%20two%20passengers%2C%20warm%20amber%20street%20lights%20and%20crimson%20bokeh%2C%20intimate%20quiet%20mood%2C%20no%20text&width=600&height=900&seq=movie-cover-16&orientation=portrait",
    rating: 8.0,
    publishDate: "2024-01-25",
    collections: ["classic", "korea", "themes"],
  },
  {
    id: "paper-crane-promise",
    title: "纸鹤之约",
    titleEn: "A Promise of Paper Cranes",
    year: 2006,
    region: "日本",
    lengthType: "长片",
    duration: 128,
    genres: ["经典", "爱情", "剧情"],
    director: "佐久间洋",
    cast: ["森下诗织", "佐久间达也", "小林薰"],
    synopsis:
      "小镇医院的护士与长期住院的年轻人，用一千只纸鹤约定了一个不可能实现的将来。多年后，已经成年的她回到那间病房，才发现纸鹤一直被人重新折过。",
    cover:
      "https://readdy.ai/api/search-image?query=Classic%20romantic%20drama%20poster%2C%20hospital%20room%20window%20with%20hanging%20paper%20cranes%20and%20soft%20afternoon%20light%2C%20warm%20amber%20and%20faded%20crimson%20tones%2C%20nostalgic%20tender%20composition%2C%20no%20text&width=600&height=900&seq=movie-cover-17&orientation=portrait",
    rating: 9.2,
    publishDate: "2024-02-02",
    collections: ["classic", "popular", "japan"],
  },
  {
    id: "rooftop-garden",
    title: "顶楼花园",
    titleEn: "The Rooftop Garden",
    year: 2025,
    region: "韩国",
    lengthType: "长片",
    duration: 94,
    genres: ["都市", "剧情", "浪漫"],
    director: "李书妍",
    cast: ["金泰梨", "柳俊烈", "申惠善"],
    synopsis:
      "首尔一栋老旧公寓的顶楼，被住户们偷偷种成了一座花园。两个在白天毫无交集的邻居，因为一株快要枯死的绣球花开始说话。城市很高，人心很低。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20poster%2C%20rooftop%20garden%20above%20Seoul%20at%20golden%20hour%20with%20potted%20hydrangeas%20and%20two%20figures%2C%20warm%20amber%20and%20deep%20crimson%20sky%2C%20gentle%20urban%20romance%20mood%2C%20no%20text&width=600&height=900&seq=movie-cover-18&orientation=portrait",
    rating: 8.8,
    publishDate: "2025-08-08",
    collections: ["recent", "popular", "korea", "themes"],
  },
  {
    id: "humid-summer",
    title: "潮湿的夏天",
    titleEn: "A Humid Summer",
    year: 2013,
    region: "日本",
    lengthType: "短片",
    duration: 45,
    genres: ["青春", "激情", "文艺"],
    director: "大野枫",
    cast: ["佐伯优", "大野遥"],
    synopsis:
      "乡下外婆家的最后一个暑假，两个即将升上大学的高中生在蝉鸣和暴雨之间，完成了他们的成人礼。整部短片没有一个多余镜头，像一段被汗水和雨浸透的记忆。",
    cover:
      "https://readdy.ai/api/search-image?query=Artistic%20short%20film%20poster%2C%20humid%20Japanese%20countryside%20summer%20with%20cicadas%2C%20two%20teenage%20silhouettes%20under%20a%20sudden%20rainstorm%2C%20amber%20and%20crimson%20saturated%20palette%2C%20nostalgic%20grain%2C%20no%20text&width=600&height=900&seq=movie-cover-19&orientation=portrait",
    rating: 8.1,
    publishDate: "2024-09-05",
    collections: ["classic", "japan", "themes"],
  },
  {
    id: "man-in-the-mirror",
    title: "镜中之人",
    titleEn: "The Man in the Mirror",
    year: 2022,
    region: "日本",
    lengthType: "长片",
    duration: 117,
    genres: ["悬疑", "心理", "剧情"],
    director: "坂本圭吾",
    cast: ["木村悠真", "水原希子", "高桥一生"],
    synopsis:
      "一位舞台剧演员在排练《镜中人》期间，发现家里所有镜子里的人都比他慢半拍。当他在镜前遇见了另一个版本的自己，属于他的生活开始被一点点替换。",
    cover:
      "https://readdy.ai/api/search-image?query=Psychological%20mystery%20poster%2C%20ornate%20antique%20mirror%20in%20a%20dark%20room%20reflecting%20a%20man&width=600&height=900&seq=movie-cover-20&orientation=portrait's silhouette%2C fractured glass effect%2C deep crimson and charcoal palette%2C unsettling elegant mood%2C no text",
    rating: 8.9,
    publishDate: "2024-12-24",
    collections: ["popular", "japan", "themes"],
  },
];

export const heroSlides = [
  {
    movieId: "glass-and-fog",
    tagline: "2025 全新力作 · 独家专题",
    image:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20still%20of%20a%20foggy%20glass%20workshop%20at%20night%2C%20antique%20mirror%20and%20soft%20crimson%20rim%20light%2C%20blurred%20female%20silhouette%2C%20deep%20shadows%20and%20warm%20amber%20highlights%2C%20artistic%20film%20noir%20atmosphere%2C%20no%20text&width=1600&height=900&seq=hero-slide-01&orientation=landscape",
  },
  {
    movieId: "crimson-room",
    tagline: "经典重映 · 悬疑禁忌之作",
    image:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20still%20of%20a%20deep%20crimson%20curtained%20room%20with%20a%20lone%20shadowed%20figure%2C%20dramatic%20chiaroscuro%20lighting%2C%20heavy%20velvet%20textures%2C%20mysterious%20elegant%20film%20noir%20atmosphere%2C%20no%20text&width=1600&height=900&seq=hero-slide-02&orientation=landscape",
  },
  {
    movieId: "rooftop-garden",
    tagline: "2025 夏季新片 · 都市浪漫",
    image:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20still%20of%20a%20Seoul%20rooftop%20garden%20at%20golden%20hour%2C%20potted%20flowers%20and%20city%20skyline%2C%20warm%20amber%20sunlight%20with%20deep%20crimson%20sky%2C%20soft%20bokeh%2C%20tender%20cinematic%20atmosphere%2C%20no%20text&width=1600&height=900&seq=hero-slide-03&orientation=landscape",
  },
  {
    movieId: "sakura-inn",
    tagline: "典藏单元 · 樱花旅馆",
    image:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20still%20of%20a%20traditional%20Japanese%20inn%20corridor%20with%20falling%20cherry%20blossoms%2C%20warm%20lantern%20glow%20and%20crimson%20shadows%2C%20rain-wet%20wooden%20floor%2C%20nostalgic%20elegant%20atmosphere%2C%20no%20text&width=1600&height=900&seq=hero-slide-04&orientation=landscape",
  },
];